import Network from "../../miniviews/network";
import { LAYER_NONE, LAYER_STENCIL } from "../../miniviews/gate";

class RenderGatesPass extends THREE.Pass {
    constructor(scene, camera, overrideMaterial, clearColor, clearAlpha) {
        super();

        this.scene = scene;
        this.camera = camera;

        this.overrideMaterial = overrideMaterial;

        this.clearColor = clearColor;
        this.clearAlpha = (clearAlpha !== undefined) ? clearAlpha : 0;

        this.clear = true;
        this.clearDepth = false;
        this.needsSwap = false;

        this._gates = [];
    }

    setGates(gates) {
        this._gates = gates;
    }

    /**
     * 
     * @param {THREE.WebGLRenderer} renderer 
     * @param {*} writeBuffer 
     * @param {*} readBuffer 
     * @param {*} delta 
     * @param {*} maskActive 
     */
    render(renderer, writeBuffer, readBuffer, delta, maskActive) {

        const camera = this.camera;
        const scene = this.scene;

        renderer.autoClear = false;

        const gl = renderer.getContext();

        gl.enable(gl.STENCIL_TEST);
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        renderer.clear(true, true, true);

        scene.updateMatrix();
        scene.updateMatrixWorld();

        Network.renderParent(renderer, camera, 0, this.renderToScreen ? null : readBuffer);

        renderer.clearDepth();

        let layer = 0;
        const gates = this._gates;

        gates.forEach(el => {
            if (el.isGate && el.visible) {
                el.update();

                layer++;

                camera.layers.set(LAYER_STENCIL);

                gl.colorMask(false, false, false, false);
                gl.depthMask(false);

                gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
                gl.stencilFunc(gl.ALWAYS, layer, 0xff);

                renderer.render(el, camera, this.renderToScreen ? null : readBuffer);
                el.render(renderer, camera, layer, this.renderToScreen ? null : readBuffer);
            }
        });

        renderer.clearDepth();

        gates.forEach(el => {
            if (el.isGate && el.visible) {
                gl.colorMask(false, false, false, false);
                gl.depthMask(true);

                gl.stencilFunc(gl.NOTEQUAL, 0, 0xff);
                gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);

                renderer.render(el.scene, camera, this.renderToScreen ? null : readBuffer);
            }
        });

        gl.colorMask(true, true, true, true);
        gl.depthMask(true);
        gl.stencilFunc(gl.EQUAL, 0, 0xff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);

        camera.layers.set(LAYER_NONE);
    }
}

class FinalizeGatesPass extends THREE.Pass {
    constructor(scene, camera, overrideMaterial, clearColor, clearAlpha) {
        super();

        this.scene = scene;
        this.camera = camera;

        this.overrideMaterial = overrideMaterial;

        this.clearColor = clearColor;
        this.clearAlpha = (clearAlpha !== undefined) ? clearAlpha : 0;

        this.clear = true;
        this.clearDepth = false;
        this.needsSwap = false;
    }

    render(renderer, writeBuffer, readBuffer, delta, maskActive) {
        const gl = renderer.getContext();
        gl.disable(gl.STENCIL_TEST);
    }
}

export { RenderGatesPass, FinalizeGatesPass };